import AuthLayout from '../AuthLayout';
import Login from '../Forms/Login';

const LoginPage = () => {
  return (
    <AuthLayout title="Sign In" subtitle="Please sign in to your account">
      <Login />
    </AuthLayout>
  );
};

export default LoginPage;
